import { baseSiteUrl } from "../components/utils";

export const sendSolutionEmail = async (toAddress: string,customerName: string, question: string, 
  product1: any, product2: any, product3: any, product4: any,
  suggestion: any
) => {
  const apiUrl = 'https://d2of6lx5t41eiu.cloudfront.net/SendSolutionEmail/sendSolutionEmail';
  const headers = {
      "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
  };

  const data = {
    "toAddress": toAddress,
    "customerName": customerName,
    "query": question,
    "suggestion": suggestion,
    "step1": {},
    "step2": {},
    "step3": {},
    "step4": {}
  }

  if (product1 !== null) {
    data.step1 = {
      "product": {
        "name": product1.name,
        "price": product1.price,
        "link": baseSiteUrl + `/product?code=${product1.code}`,
        "brand": product1.brand
      }
    }
  }

  if (product2 !== null) {
    data.step2 = {
      "product": {
        "name": product2.name,
        "price": product2.price,
        "link": baseSiteUrl + `/product?code=${product2.code}`,
        "brand": product2.brand
      }
    }
  }

  if (product3 !== null) {
    data.step3 = {
      "product": {
        "name": product3.name,
        "price": product3.price,
        "link": baseSiteUrl + `/product?code=${product3.code}`,
        "brand": product3.brand
      }
    }
  }

  if (product4 !== null) {
    data.step4 = {
      "product": {
        "name": product4.name,
        "price": product4.price,
        "link": baseSiteUrl + `/product?code=${product4.code}`,
        "brand": product4.brand
      }
    }
  }

  const response = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });
};